import { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CollaborationContext = createContext(null);
export const useCollaboration = () => useContext(CollaborationContext);

export const CollaborationProvider = ({ children }) => {
  const { user } = useAuth();
  const [activeUsers, setActiveUsers] = useState([]);
  const [recentChanges, setRecentChanges] = useState([]);
  const pageRef = useRef("/");

  const setCurrentPage = useCallback((page) => {
    pageRef.current = page;
  }, []);

  // Heartbeat every 10s
  useEffect(() => {
    if (!user) return;
    const beat = async () => {
      try {
        await axios.post(`${API}/collaboration/heartbeat`,
          { page: pageRef.current },
          { withCredentials: true }
        );
      } catch (e) {
        console.error("Collaboration heartbeat failed:", e?.response?.status || e?.message);
      }
    };
    beat();
    const interval = setInterval(beat, 10000);
    return () => clearInterval(interval);
  }, [user]);

  // Poll status every 8s
  useEffect(() => {
    if (!user) return;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/collaboration/status`, { withCredentials: true });
        setActiveUsers(res.data.active_users || []);
        setRecentChanges(res.data.recent_changes || []);
      } catch (e) {
        console.error("Collaboration status poll failed:", e?.response?.status || e?.message);
      }
    };
    poll();
    const interval = setInterval(poll, 8000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <CollaborationContext.Provider value={{ activeUsers, recentChanges, setCurrentPage }}>
      {children}
    </CollaborationContext.Provider>
  );
};
